import { render, staticRenderFns } from "./ItemEdit_Dispatches_Edit.vue?vue&type=template&id=5e45f64e&"
import script from "./ItemEdit_Dispatches_Edit.vue?vue&type=script&lang=js&"
export * from "./ItemEdit_Dispatches_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports